import React from "react";
import { FaCopyright, FaPenFancy } from "react-icons/fa";
import "./Endfooter.css";
import { Link, useNavigate } from "react-router-dom";

const Endfooter = () => {
  const navigate = useNavigate();
  return (
    <footer className="endfooter ">
      <div className="footer-container">
        <div className="footer-content">
          {/* Copyright Section */}
          <div className="footer-section copyright-section">
            <p className="footer-text">
              <FaCopyright className="footer-icon" />{" "}
              <Link to="/" className="footer-link">
                Kalanjiyam
              </Link>{" "}
              <span className="footer-year">2025</span> - © Exclusive Content |
              All Rights Reserved
            </p>
          </div>

          {/* Developer Section */}
          <div className="footer-section developer-section">
            <p className="footer-text">
              <FaPenFancy className="footer-icon" /> Designed & Developed by{" "}
              <a
                href="https://www.idlbay.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                IDLBAY Pvt Ltd.
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Endfooter;
